import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'

export const styles = (breakpoint: number) => {
  let overRideListStyle: BoxProps = {}
  let overideIconViewStyle: BoxProps = {}
  let overRiderSearchListItemStyle: BoxProps = {}
  // let overrideSearchTextLayoutStyle: BoxProps = {}

  if (breakpoint < 982 && breakpoint > 931) {
    overRideListStyle = {
      top: 101,
      left: 238,
    } as BoxProps
  }
  if (breakpoint <= 931 && breakpoint >= 850) {
    overRideListStyle = {
      top: 101,
      left: 238,
    } as BoxProps
  }
  if (breakpoint <= 851 && breakpoint > 810) {
    overRideListStyle = {
      top: 55,
      left: 66,
    } as BoxProps
  }

  if (breakpoint <= 810 && breakpoint >= 690) {
    overRideListStyle = {
      top: 101,
      left: 66,
    } as BoxProps
  }
  if (breakpoint < 690 && breakpoint >= 630) {
    overRideListStyle = {
      top: 101,
      left: 64,
    } as BoxProps
  }
  if (breakpoint < 630) {
    overideIconViewStyle = {
      display: 'none',
    } as BoxProps
    overRideListStyle = {
      minWidth: '85%',
      top: 86,
      left: 64,
      maxWidth: '85%',
      maxHeight: '90%',
    } as BoxProps
    overRiderSearchListItemStyle = {
      paddingHorizontal: 0,
      paddingVertical: 0,
    } as BoxProps
    // overrideSearchTextLayoutStyle = {
    //   paddingVertical: 8,
    //   flexDirection: 'row-reverse',
    // }
  }
  return {
    containerBox: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: 'WHITE',
      borderRadius: 2,
      paddingHorizontal: 14,
      paddingVertical: 0,
      margin: 0,
    } as BoxProps,
    textInputContainer: {
      flexDirection: 'row',
      borderRadius: 4,
      alignItems: 'center',
      paddingRight: 4,
    } as BoxProps,
    iconContainer: { paddingRight: 8, width: 18 } as BoxProps,
    dropdown: {
      position: 'absolute',
      height: '100vh',
      width: 560,
      top: -40,
      left: 185,
      justifyContent: 'center',
      backgroundColor: 'TRANSPARENT',
    } as BoxProps,
    icon: {
      fontSize: 16,
      color: 'LIGHT_GREY',
      alignContent: 'center',
      paddingRight: 4,
    } as TextProps,
    title: {
      fontSize: 12,
      color: 'LIGHT_GREY',
      paddingHorizontal: 4,
      textAlign: 'left',
      width: '100%',
    } as TextProps,
    list: {
      flex: 1,
      position: 'absolute',
      top: 55,
      left: 238,
      maxHeight: 332,
      w: 527,
      backgroundColor: 'WHITE',
      shadowOffset: { width: 0, height: 2 },
      shadowRadius: 12,
      shadowColor: 'GRAY_SHADOW',
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8,
      borderWidth: 1,
      borderColor: '#00000014' as ColorOptions,
      zIndex: 8,
      marginTop: 10,
      ...overRideListStyle,
    } as BoxProps,
    emptyView: {
      alignItems: 'center',
      paddingVertical: 50,
      paddingHorizontal: 52,
      justifyContent: 'center',
      minWidth: 527,
    } as BoxProps,
    emptyTitleStyle: { fontSize: 12, color: 'BLACK', fontWeight: 'MEDIUM' } as TextProps,
    emptySubTitleStyle: { fontSize: 12, color: 'BRAND_THEME', fontWeight: 'MEDIUM' } as TextProps,
    filterContainer: {
      backgroundColor: 'TEAL',
      padding: 2,
      paddingHorizontal: 6,
      borderRadius: 2,
    } as BoxProps,
    searchDurationViewStyle: {
      alignItems: 'flex-end',
      justify: 'flex-end',
      flexDirection: 'row',
      width: 120,
    } as BoxProps,
    searchIconContainer: {
      bg: '#0186B014' as ColorOptions,
      w: 48,
      h: 40,
      align: 'center',
      justify: 'center',
      underlayColor: 'TRANSPARENT',
    } as BoxProps,
    listheader: {
      borderBottomWidth: 1,
      paddingHorizontal: 18,
      paddingVertical: 8,
      marginHorizontal: -2,
      marginBottom: 0,
      borderColor: 'GREY_SEPARATOR',
    } as BoxProps,
    recentsTextStyle: {
      fontSize: 12,
      color: 'BLACK',
      letterSpacing: 1.2,
      paddingVertical: 18,
      fontFamily: 'jiotype-medium',
      paddingLeft: 54,
      borderBottomColor: 'GREY_SEPARATOR',
      borderBottomWidth: 1,
    } as TextProps,
    listfooter: {
      flexDirection: 'row',
      backgroundColor: 'BACKGROUND',
      margin: 0,
      paddingHorizontal: 18,
      paddingVertical: 12,
      borderBottomLeftRadius: 4,
      borderBottomRightRadius: 4,
    } as BoxProps,
    searchTextLayoutStyle: (isMobile: boolean) =>
      ({
        paddingHorizontal: isMobile ? 18 : 12,
        w: isMobile ? '100%' : undefined,
        pv: 3,
        flexDirection: isMobile ? 'row' : 'column',
        justifyContent: isMobile ? 'space-between' : undefined,
      } as BoxProps),
    searchTitleStyle: (isMobile: boolean) =>
      ({
        fontWeight: 'MEDIUM',
        fontSize: isMobile ? 12 : 14,
        textAlign: 'left',
        color: 'PRIMARY_GREY',
      } as TextProps),
    highlightStyle: (isMobile: boolean, isRecents: boolean) =>
      ({
        fontWeight: 'bold',
        fontSize: isMobile ? 12 : 14,
        textAlign: 'left',
        color: isRecents ? 'LIGHT_BLACK' : 'BLACK',
      } as TextProps),
    searchSubTitleText: () =>
      ({
        fontSize: 12,
        textAlign: 'left',
        color: 'PRIMARY_GREY',
        fontFamily: 'jiotype-medium',
      } as TextProps),
    searchItemContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingRight: 12,
    } as BoxProps,
    searchListItemStyle: {
      paddingVertical: 12,
      flexDirection: 'row',
      alignItems: 'center',
      ...overRiderSearchListItemStyle,
    } as BoxProps,
    searchtitleView: (isMobile: boolean) => ({ flexDirection: 'row', width: isMobile ? '71%' : undefined } as BoxProps),
    recentsIconView: { width: 20, height: 20, ...overideIconViewStyle } as BoxProps,
    flatListColumnStyle: { flexWrap: 'wrap' } as ViewStyle,
    flatlistContainer: { width: '90%' } as ViewStyle,
  }
}
